import { useRef } from 'react';
import { Navigate, Outlet, useLocation } from '@tanstack/react-router';
import { Center, Loader } from '@mantine/core';
import { useAuth } from '@/features/auth/hooks/useAuth';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Intended destination for the post-login redirect. useLocation() updates to
  // /login mid-transition while this component is still mounted, which re-fired
  // Navigate with the new pathname and clobbered ?redirect — every logged-out
  // deep link landed on redirect=/login and post-login users were dumped on
  // home. Track the last non-login pathname instead (idempotent per render).
  const intendedRef = useRef(location.pathname);
  if (!location.pathname.startsWith('/login')) {
    intendedRef.current = location.pathname;
  }

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" search={{ redirect: intendedRef.current }} />;
  }

  return <Outlet />;
}
